import _defineProperty from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import * as React from 'react';
import classNames from 'classnames';
import OutlineAngleDownMini from '../../icons/generated/outline/OutlineAngleDownMini.js';
import useAccordionItem from './logic.js';
var Item = function Item(_ref) {
  var accIndex = _ref.accIndex,
    open = _ref.open,
    children = _ref.children,
    _ref$titleChild = _ref.titleChild,
    titleChild = _ref$titleChild === void 0 ? "Accodion item" : _ref$titleChild,
    _ref$openedItems = _ref.openedItems,
    openedItems = _ref$openedItems === void 0 ? [] : _ref$openedItems,
    onOpenItem = _ref.onOpenItem,
    onCloseItem = _ref.onCloseItem,
    colorScheme = _ref.colorScheme,
    openCallback = _ref.openCallback,
    closeCallback = _ref.closeCallback;
  var _useAccordionItem = useAccordionItem({
      accIndex: accIndex,
      openedItems: openedItems,
      onOpenItem: onOpenItem,
      onCloseItem: onCloseItem,
      open: open,
      openCallback: openCallback,
      closeCallback: closeCallback
    }),
    isItemOpened = _useAccordionItem.isItemOpened,
    headClickHandler = _useAccordionItem.headClickHandler;
  var componentClass = classNames("iq-accordion__item", _defineProperty({
    "iq-accordion__item--open": isItemOpened
  }, "iq-accordion__item--color-s-".concat(colorScheme), !!colorScheme));
  return /* @__PURE__ */React.createElement("li", {
    className: componentClass
  }, /* @__PURE__ */React.createElement("button", {
    className: "iq-accordion__item-head",
    onClick: headClickHandler
  }, /* @__PURE__ */React.createElement("h2", {
    className: "iq-accordion__head-content"
  }, titleChild), /* @__PURE__ */React.createElement("div", {
    className: "iq-accordion__arrow-holder"
  }, /* @__PURE__ */React.createElement(OutlineAngleDownMini, null))), /* @__PURE__ */React.createElement("div", {
    className: "iq-accordion__item-body"
  }, children));
};
export { Item as default };